import { AddCircleOutline, Clear } from "@material-ui/icons";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import $ from "jquery";
import { connect } from "react-redux";
import NumericInput from "react-numeric-input";
import { currencyFormat, formatNumber } from "./../../Common/Common";
import * as code from "./../../../config/Constants";

class BrokerageFees extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fees:
        this.props.getTransactionData() &&
        this.props.getTransactionData().dsd &&
        this.props.getTransactionData().dsd.fees
          ? this.props.getTransactionData().dsd.fees
          : [],
      feesToShowOnly: [],
      drafted: this.props.getTransactionData().drafted || undefined,
      editData: {},
      isEdit: false,
      agentPercentage: 100,
      brokerPercentage: 0,
      nameErrClass: "",
      valErrClass: "",
    };
  }

  getData() {
    return this.props.getTransactionData().fees;
  }

  /**
   * @desc Add fees to state
   */
  addFees(e) {
    let feeLabel = $(".broker-fees-label ul li.title input").val();
    let feeVal = $(".broker-fees-label .value input").val();

    if (feeLabel !== "" && feeVal !== "") {
      let newF = { name: feeLabel, value: feeVal };
      let fees = this.state.fees;
      fees.push(newF);
      this.setState({ fees });
      this.props.updateTransactionData("fees", fees);
      this.setState({ drafted: undefined });
      this.props.updateTransactionData("drafted", undefined);
      this.props.updateTransactionData("updatedFee", []);

      $(".broker-fees-label .title input").val("");
      $(".broker-fees-label .value input").val("");
      this.setState({ nameErrClass: "", valErrClass: "" });
    } else {
      if (feeLabel == "") {
        this.setState({ nameErrClass: code.ERROR });
      } else {
        this.setState({ nameErrClass: "" });
      }
      if (feeVal == "") {
        this.setState({ valErrClass: code.ERROR });
      } else {
        this.setState({ valErrClass: "" });
      }
    }
  }

  /**
   * @desc save data as draft
   * drafted fees means data in input but not saved then also need to consider as fees
   */
  draftedFees() {
    let feeLabel = $(".broker-fees-label ul li.title input").val();
    let feeVal = $(".broker-fees-label .value input").val();
    if (feeLabel !== "" && feeVal !== "") {
      let drafted = { name: feeLabel, value: feeVal };

      this.setState({ drafted: drafted });
      this.props.updateTransactionData("drafted", drafted);
      this.props.updateTransactionData("updatedFee", []);
    }

    if (feeLabel !== "") {
      this.setState({ nameErrClass: "" });
    }
    if (feeVal !== "") {
      this.setState({ valErrClass: "" });
    }
  }

  //delete fees record
  deleteFeesRecord(e, ind, name) {
    let fees = this.state.fees;
    if (ind !== "") {
      delete fees[ind];
      var ar = fees.filter(function(el) {
        return el != null;
      });

      this.setState({ fees: ar });
      this.props.updateTransactionData("fees", ar);
      this.props.updateTransactionData("updatedFee", []);
    }
  }

  //edit fees record
  editFeesRecord(e, ind) {
    let fees = this.state.fees;
    let selfee = fees[ind];
    selfee.ind = ind;
    this.setState({ editData: selfee, isEdit: true });
  }

  //update fees record
  updateFeesRecord(e) {
    let fees = this.state.fees;
    let ind = this.state.editData.ind;

    let feeLabel = $(".broker-fees-label ul li.title input").val();
    let feeVal = $(".broker-fees-label .value input").val();

    if (feeLabel !== "" && feeVal !== "") {
      fees[ind].name = feeLabel;
      fees[ind].value = feeVal;

      this.setState({ fees });
      this.props.updateTransactionData("fees", fees);

      $(".broker-fees-label .title input").val("");
      $(".broker-fees-label .value input").val("");
      this.setState({ isEdit: false });
      this.props.updateTransactionData("updatedFee", []);
    }
  }

  componentDidMount() {
    if (!this.props.isCreate) {
      // console.log(
      //   "this.props.getTransactionData()",
      //   this.props.getTransactionData()
      // );
      this.setState({
        agentPercentage: this.props.getTransactionData().dsd.agentPercentage,
      });
    }
  }

  render() {
    let defaultValue = "";
    let defVal = "";

    if (this.props.isCreate) {
      if (this.props.getTransactionData().drafted !== undefined) {
        defaultValue = this.props.getTransactionData().drafted.name;
        defVal = this.props.getTransactionData().drafted.value;
      }
    }

    let label = this.state.isEdit ? this.state.editData.name : defaultValue;
    let val = this.state.isEdit ? this.state.editData.value : defVal;

    let agentPercentage = "";
    let brokerPercentage = "";
    let agentPercentageAmt = 0;
    let brokerPercentageAmt = 0;

    if (this.props.profileData !== undefined) {
      //get agent % from user profilde data
      agentPercentage =
        this.state.agentPercentage != ""
          ? this.state.agentPercentage
          : this.props.profileData.agentPercentage;
      brokerPercentage =
        this.state.agentPercentage != ""
          ? 100 - this.state.agentPercentage
          : 100 - this.props.profileData.agentPercentage;
    }

    if (
      this.props.getTransactionData().agentPercentage !== "" &&
      this.props.isCreate
    ) {
      agentPercentage = this.props.getTransactionData().agentPercentage;
      brokerPercentage = 100 - this.props.getTransactionData().agentPercentage;
    }

    // console.log("this.props.salePrice", this.props.salePrice);
    // console.log("this.props.commission", this.props.commission);
    // console.log("agentPercentagexcvxcvxc", agentPercentage);

    //calculate amount
    let saleprice = this.props.salePrice != "" ? this.props.salePrice : 0;
    let commission = this.props.commission != "" ? this.props.commission : 0;

    let commissionAmt = (saleprice * commission) / 100;
    agentPercentageAmt = (commissionAmt * agentPercentage) / 100;
    brokerPercentageAmt = commissionAmt - agentPercentageAmt;

    let isTransDrafted =
      this.props.getTransactionData() &&
      this.props.getTransactionData().dsd &&
      this.props.getTransactionData().dsd.draft;

    return (
      <Row>
        <Col xs={12}>
          <h4 className="title-small font-600 mt-2">Commission</h4>

          {!this.props.isOnlyShow && (
            <div className="brokerage-fees-main">
              <div className="brokerage-fees-main-body">
                <div className="brokerage-fees-main-row">
                  <ul>
                    <li className="title">
                      Artist<span className="text-danger"> *</span>
                    </li>
                    <li className="percent">
                      <NumericInput
                        name="agentPercentage"
                        precision={2}
                        min={0}
                        max={100}
                        inputmode="numeric"
                        strict
                        style={false}
                        className="form-control"
                        value={agentPercentage != "" ? agentPercentage : 0.0}
                        onChange={(e) => {
                          this.setState({
                            agentPercentage: e.toFixed(2),
                            brokerPercentage: (100 - e).toFixed(2),
                          });
                          this.props.updateTransactionData(
                            "agentPercentage",
                            e
                          );
                        }}
                      />
                    </li>
                    <li className="value">
                      <input
                        type="text"
                        className="form-control text-right"
                        disabled
                        value={
                          agentPercentageAmt
                            ? currencyFormat(agentPercentageAmt)
                            : ""
                        }
                      />
                    </li>
                  </ul>
                </div>
                <div className="brokerage-fees-main-row">
                  <ul>
                    <li className="title">Studio</li>
                    <li className="percent">
                      <NumericInput
                        name="brokerPercentage"
                        precision={2}
                        min={0.01}
                        max={100}
                        inputmode="numeric"
                        strict
                        style={false}
                        className="form-control"
                        value={brokerPercentage}
                        onChange={(e) => {
                          return false;
                        }}
                        readOnly
                      />
                    </li>
                    <li className="value">
                      <Form.Control
                        type="text"
                        className="form-control text-right"
                        disabled
                        value={
                          brokerPercentageAmt
                            ? currencyFormat(brokerPercentageAmt)
                            : ""
                        }
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
          <h4 className="title-small font-600 mt-2">Fees</h4>
          <div className="brokerage-fees mb-3">
            {this.state.fees && this.state.fees.length > 0 && (
              <div className="brokerage-fees-body">
                {this.state.fees &&
                  this.state.fees.map((name, ind) => {
                    if (name !== null) {
                      if (
                        (isTransDrafted && name.name == "Brokerage Fee") ||
                        (!this.props.isCreate &&
                          !this.props.isOnlyShow &&
                          name.name === "Brokerage Fee")
                      ) {
                        return "";
                      } else {
                        return (
                          <div
                            className="brokerage-fees-row"
                            key={"broker-fees-" + ind}
                          >
                            <ul>
                              <li className="title">{name.name}</li>
                              <li className="value">
                                ${formatNumber(name.value)}
                              </li>
                              <li className="status">
                                <Button
                                  variant="transparent"
                                  onClick={(e) =>
                                    this.deleteFeesRecord(e, ind, name)
                                  }
                                >
                                  <Clear className="clear" />
                                </Button>
                              </li>
                            </ul>
                          </div>
                        );
                      }
                    }
                  })}
              </div>
            )}

            <div className="brokerage-fees-footer">
              <div
                className={
                  this.props.addCls
                    ? "brokerage-fees-row broker-fees-label"
                    : "brokerage-fees-row"
                }
              >
                <ul>
                  <li className="title">
                    <input
                      type="text"
                      className={"form-control " + this.state.nameErrClass}
                      placeholder="Name/Date"
                      defaultValue={label}
                      onChange={() => this.draftedFees()}
                      onKeyDown={(e) => {
                        if (e.keyCode == 13) {
                          e.preventDefault();
                          if (this.state.isEdit) {
                            this.updateFeesRecord(e);
                          } else {
                            this.addFees(e);
                          }
                        }
                      }}
                    />
                  </li>
                  <li className="value">
                    <input
                      type="number"
                      className={"form-control " + this.state.valErrClass}
                      placeholder="Amount"
                      defaultValue={val}
                      onChange={() => this.draftedFees()}
                      onKeyDown={(e) => {
                        if (e.keyCode == 13) {
                          e.preventDefault();
                          if (this.state.isEdit) {
                            this.updateFeesRecord(e);
                          } else {
                            this.addFees(e);
                          }
                        }
                      }}
                    />
                  </li>
                  <li className="status">
                    <Button
                      variant="transparent"
                      onClick={(e) => {
                        if (this.state.isEdit) {
                          this.updateFeesRecord(e);
                        } else {
                          this.addFees(e);
                        }
                      }}
                    >
                      <AddCircleOutline className="add" />
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profileData: state.reducer.profileData,
  };
};

export default connect(
  mapStateToProps,
  {}
)(BrokerageFees);
